import type { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import { createApi } from "@reduxjs/toolkit/query/react";

import type { AxiosRequestConfig } from "axios";
import { convertArrayParams } from "utils";
import axiosInstance from "./axios";

interface ErrorModel {
  statusCode: number;
  errorType: string;
  errorMessage: string;
  content?: any;
}
const axiosBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        timeout: Number(process.env.NEXT_PUBLIC_TIME_OUT) || 30000,
        validateStatus(status: number) {
          return status >= 200 && status < 300;
        },
        paramsSerializer: convertArrayParams
      });
      return { data: result };
    } catch (axiosError) {
      let err = axiosError as ErrorModel;
      return {
        error: {
          status: err?.statusCode,
          data:{
            message:err?.errorMessage,
            type:err?.errorType
          }
        },
      };
    }
  };

const apiSlice = createApi({
  reducerPath: "allApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({}),
});

export default apiSlice;
